import { LazyLoadImage } from '@/components/lazy-load-image';
import Link from 'next/link';
import { FC } from 'react';
import styles from './card.module.scss';

export interface CardIntegrationsProps {
    logo?: string;
    logoHeight?: number;
    title?: string;
    description?: string;
    linkTo?: string;
    ctaLabel?: string;
}

const CardContent: FC<CardIntegrationsProps> = ({ logo, logoHeight, title, description, ctaLabel, linkTo }) => (
    <div className={styles.card}>
        {logo && (
            <div className={styles.wrapLogo}>
                <div className={styles.box} style={{ height: logoHeight ? `${logoHeight}px` : '' }}>
                    <LazyLoadImage className={styles.logo} imageUrl={logo} objectPosition={'left'} />
                </div>
            </div>
        )}
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
        {linkTo && ctaLabel ? <div className={styles.cta}>{ctaLabel}</div> : null}
    </div>
);

const CardIntegrations: FC<CardIntegrationsProps> = ({ linkTo, ...props }) => (
    <Link href={linkTo || ''} passHref>
        {linkTo ? (
            <a
                target={linkTo.startsWith('/') ? undefined : '_blank'}
                rel={linkTo.startsWith('/') ? undefined : 'noopener noreferrer'}
                style={{ textDecoration: 'unset' }}
            >
                <div className={styles.container}>
                    <CardContent {...props} linkTo={linkTo} />
                </div>
            </a>
        ) : (
            <div className={styles.container} onClick={(e) => !linkTo && e.preventDefault()}>
                <CardContent {...props} linkTo={linkTo} />
            </div>
        )}
    </Link>
);

export default CardIntegrations;
